import { Query, SearchPillData } from "../../interfaces";

export function locationSearchPills(
  appState: Query,
  staticPill?: boolean,
): SearchPillData[] {
  return [
    {
      label: "State",
      value: appState.filters.stalp,
      search: false,
      static: staticPill,
      formKey: "stalp",
    },
    {
      label: "Zip",
      value: appState.filters.zip,
      search: false,
      static: staticPill,
      formKey: "zip",
    },
    {
      label: "City",
      value: appState.search.city,
      search: true,
      static: staticPill,
      formKey: "city",
    },
  ];
}
